export const cars = [
  {
    id: 'bezza',
    name: 'Bezza',
    tagline: 'BEYOND COMPACT',
    price: 'RM34,580',
    image: 'bezza.webp',
    imageinfo: 'bezza_info.webp',
    category: 'Sedan',
    description: "Malaysia's Favourite Sedan. Spacious, fuel-efficient, and built for your family's journey.",
    colors: [
      { name: 'Garnet Red', hex: '#872124', image: 'colors/bezza/garnetred.png' },
      { name: 'Garnite Grey', hex: '#71797E', image: 'colors/bezza/garnitegrey.png' },
      { name: 'Glittering Silver', hex: '#C0C0C0', image: 'colors/bezza/glitteringsilver.png' },
      { name: 'Ivory White', hex: '#FFFFF0', image: 'colors/bezza/ivorywhite.png' },
      { name: 'Ocean Blue', hex: '#1F4788', image: 'colors/bezza/oceanblue.png' },
      { name: 'Sugar Brown', hex: '#8B4513', image: 'colors/bezza/sugarbrown.png' }
    ],
    variants: [
      { name: 'Bezza 1.0 G (Manual)', price: 'RM 34,580', installment: '', features: [] },
      { name: 'Bezza 1.0 G (Automatic)', price: 'RM 36,580', installment: '', features: [] },
      { name: 'Bezza 1.3 X (Automatic)', price: 'RM 43,980', installment: '', features: [] },
      { name: 'Bezza 1.3 AV (Automatic)', price: 'RM 49,980', installment: '', features: [] }
    ],
    safety: [
      '5-Star ASEAN NCAP Safety Rating',
      'Advanced Safety Assist (A.S.A) 2.0',
      'Vehicle Stability Control (VSC)',
      'Traction Control (TRC)',
      'Hill-Start Assist (HSA)',
      'Anti-lock Braking System (ABS) with Electronic Brake Distribution (EBD)',
      'Seat Belt Reminder for Driver and Front Passenger',
      'One-touch Function with Jam Protection on Driver\'s Side'
    ],
    features: [
      { title: '508L Boot Space', description: 'The largest luggage capacity in its class. Perfect for family balik kampung or groceries.' },
      { title: 'EEV Engine Efficiency', description: 'Up to 22.8km/l for 1.3L variants with Eco Idle. Save more on every trip.' },
      { title: 'Safety First', description: 'ASEAN NCAP 5-Star rating. Advanced Safety Assist (A.S.A) 2.0 keeps you safe.' }
    ],
    exterior: [
      { name: 'LED Headlamps', image: 'features/bezza/style_bezza_newledheadlamps_img_1_5x.webp' },
      { name: 'Front Grille & Bumper', image: 'features/bezza/style_bezza_frontgrillebumper_img_1_5x.webp' },
      { name: 'Two-tone 15-inch Alloy Rims', image: 'features/bezza/style_bezza_twotone15inchrims_img_1_5x.webp' },
      { name: 'Retractable Side Mirrors with Turn Signals', image: 'features/bezza/style_bezza_retractablesidemirror_img_1_5x.webp' },
      { name: 'Two-tone Side Skirtings', image: 'features/bezza/style_bezza_twotonwskirting_img_1_5x.webp' },
      { name: 'Two-tone Back Door Garnish', image: 'features/bezza/style_bezza_newtwotonebackdoor_img_1_5x.webp' },
      { name: 'Rear Bumper', image: 'features/bezza/style_bezza_newtrearbumper_img_1_5x.webp' },
      { name: 'Smart Entry with Smart Key', image: 'features/bezza/style_bezza_smartentry_img_1_5x.webp' },
    ],
    interior: [
      { name: 'Semi-bucket Leather Seats', image: 'features/bezza/conv_bezza_leatherseats_img_1x.webp' },
      { name: 'Smart Entry with Smart Key and Push Start/Stop Button', image: 'features/bezza/conv_bezza_smartentry_img_1x.webp' },
      { name: 'Meter Combi (White Illumination)', image: 'features/bezza/conv_bezza_metercombi_img_1x.webp' },
      { name: 'Multimedia System with Navigation and Smart Link (For Android Only)', image: 'features/bezza/conv_bezza_mmediasystem_img_1x.webp' },
      { name: 'Handphone Slot and USB Port (Rear Console)', image: 'features/bezza/conv_bezza_handphoneslot_img_1x.webp' }
    ],
    gearupExterior: [
      { name: 'Dynamic Bodykit', image: 'features/bezza/style_bezzagup_dynamickit_img.gif' },
      { name: 'Door Visors', image: 'features/bezza/style_bezza_frontgrillebumper_thumb_1x.webp' },
      { name: 'Side Door Protectors', image: 'features/bezza/style_bezza_twotone15inchrims_thumb_1x.webp' },
      { name: 'Chrome Window Garnish', image: 'features/bezza/style_bezza_retractablesidemirror_thumb_1x.webp' },
      { name: 'Stylish Package', image: 'features/bezza/style_bezza_twotonwskirting_thumb_1x.webp' }
    ],
    gearupInterior: [
      { name: 'Dynamic Seat Covers', image: 'features/bezza/conv_bezza_gupdynamicseatcovers.gif' },
      { name: 'Arm Rest with USB Port', image: 'features/bezza/conv_bezza_guparmrest_thumb_1x.webp' },
      { name: 'Magnetic Sun Shades', image: 'features/bezza/conv_bezza_gupmagneticshade_thumb_1x.webp' },
      { name: 'Coil Mats', image: 'features/bezza/conv_bezza_gupcoilmatsmeshtop_thumb_1x.webp' },
      { name: 'Floor Lighting', image: 'features/bezza/conv_bezza_floorlighting_thumb_1x.webp' },
      { name: 'LED Scuff Plates', image: 'features/bezza/conv_bezza_ledplates_thumb_1x.webp' },
      { name: 'Chrome Scuff Plates', image: 'features/bezza/conv_bezza_chromseplates_thumb_1x.webp' },
      { name: 'Luggage Tray', image: 'features/bezza/conv_bezza_lggtray_thumb_1x.webp' },
      { name: 'Hood Insulator', image: 'features/bezza/conv_bezza_hoodinsulator_thumb_1x.webp' },
      { name: 'Door Comfort', image: 'features/bezza/conv_bezza_doorcomfort_thumb_1x.webp' },
      { name: 'Utility Package', image: 'features/bezza/conv_bezza_utilitypckg_thumb_1x.webp' },
      { name: 'Illumination Package', image: 'features/bezza/conv_bezza_illumintationpckg_thumb_1x.webp' }
    ]
  },
  {
    id: 'axia',
    name: 'Axia',
    tagline: 'SMART & EFFICIENT',
    price: 'RM22,000',
    image: 'axia.webp',
    imageinfo: 'axia_info.webp',
    category: 'Hatchback',
    description: 'The perfect city car. Compact, efficient, and designed for urban adventures.',
    colors: [
      { name: 'Coral Blue', hex: '#58C9D4', image: 'colors/axia/coralblue.png' },
      { name: 'Glittering Silver', hex: '#C0C0C0', image: 'colors/axia/glitteringsilver.png' },
      { name: 'Granite Grey', hex: '#71797E', image: 'colors/axia/granitegrey.png' },
      { name: 'Ivory White', hex: '#FFFFF0', image: 'colors/axia/ivorywhite.png' },
      { name: 'Lava Red', hex: '#C41E3A', image: 'colors/axia/lavared.png' }
    ],
    variants: [
      { name: 'Axia 1.0L E (Manual)', price: 'RM 22,000', installment: '', features: [] },
      { name: 'Axia 1.0L G (D-CVT)', price: 'RM 38,600', installment: '', features: [] },
      { name: 'Axia 1.0L X (D-CVT)', price: 'RM 40,000', installment: '', features: [] },
      { name: 'Axia 1.0L SE (D-CVT)', price: 'RM 44,000', installment: '', features: [] },
      { name: 'Axia 1.0L AV (D-CVT)', price: 'RM 49,500', installment: '', features: [] }
    ],
    safety: [
      '5-Star ASEAN NCAP Safety Rating',
      'Advanced Safety Assist (A.S.A) 2.0',
      'Vehicle Stability Control (VSC)',
      'Anti-lock Braking System (ABS) with Electronic Brake Distribution (EBD)',
      'Seat Belt Reminder'
    ],
    features: [
      { title: 'Compact Design', description: 'Perfect for city driving and easy parking in tight spaces.' },
      { title: 'Fuel Efficient', description: 'Outstanding fuel economy with EEV technology for maximum savings.' },
      { title: 'Affordable', description: 'The most affordable entry point into the Perodua family.' }
    ],
    exterior: [
      { name: 'Chrome Front Grill with Front Skirt', image: 'features/axia/chrome_frtgrill_thumb_1x.webp' },
      { name: 'LED Headlamps and Daytime Running Lights', image: 'features/axia/led_headlamp_thumb_1x.webp' },
      { name: 'Side Skirtings', image: 'features/axia/side_skirting_thumb_1x.webp' },
      { name: 'Rear Spoiler', image: 'features/axia/rear_spoiler_thumb_1x.webp' },
      { name: 'Key-Free Entry', image: 'features/axia/keyfree_thumb_1x.webp' },
      { name: 'Retractable Side Mirrors', image: 'features/axia/retractable_sidemirrors_thumb_1x.webp' }
    ],
    interior: [
      { name: 'Push Start/Stop Button', image: 'features/axia/push_starts_thumb_1x.webp' },
      { name: 'Central Lock', image: 'features/axia/central_lock_thumb_1x.webp' },
      { name: '265L Luggage Space Capacity', image: 'features/axia/265l_luggage_space_thumb_1x.webp' },
      { name: 'Monotone Instrument Panel with Silver Finishing', image: 'features/axia/conv_bezza_monotonepanel_thumb_1x.webp' },
      { name: 'Semi Bucket Seat with Semi-Leather and Stitching', image: 'features/axia/conv_axia_semibucketseat_thumb_1x.webp' },
      { name: '7” TFT Multi Info Display', image: 'features/axia/conv_axia_7tftmultiinfodisplay_thumb_1x.webp' },
      { name: '9” Display Audio', image: 'features/axia/conv_axia_9displayaudio_thumb_1x.webp' }
    ],
    gearupExterior: [
      { name: 'Door Visors', image: 'features/axia/door_visor_thumb_1x.webp' },
      { name: 'Utility Package', image: 'features/axia/aaa.utility_package_thumb_1x' }
    ],
    gearupInterior: [
      { name: 'Trendy Seat Covers', image: 'features/axia/trendy-seat-covers-thumbnail-ezgif.com-resize.webp' },
      { name: 'LED Scuff Plates', image: 'features/axia/led-scuff-plates-thumbnail-ezgif.com-resize.webp' },
      { name: 'Floor Lighting', image: 'features/axia/floor-lighting-thumbnail-ezgif.com-resize.webp' },
      { name: 'Coil Mats', image: 'features/axia/coil_mats_thumbnail_1x.webp' },
      { name: 'Luggage Tray', image: 'features/axia/luggage_tray_thumb_1x.webp' },
      { name: 'Hood Insulator', image: 'features/axia/conv_bezza_monotonepanel_thumb_1x.webp' },
      { name: 'Utility Package', image: 'features/axia/utility_package_thumb_1x.webp' }
    ]
  },
  {
    id: 'myvi',
    name: 'Myvi',
    tagline: 'KING OF THE ROAD',
    price: 'RM46,500',
    image: 'myvi.webp',
    imageinfo: 'myvi_info.webp',
    category: 'Hatchback',
    description: 'Malaysia\'s best-selling car. Versatile, reliable, and packed with features.',
    colors: [
      { name: 'Cranberry Red', hex: '#9B111E', image: 'colors/myvi/cranberryred.png' },
      { name: 'Electric Blue', hex: '#7DF9FF', image: 'colors/myvi/electricblue.png' },
      { name: 'Glittering Silver', hex: '#C0C0C0', image: 'colors/myvi/glitteringsilver.png' },
      { name: 'Granite Grey', hex: '#71797E', image: 'colors/myvi/granitegrey.png' },
      { name: 'Ivory White', hex: '#FFFFF0', image: 'colors/myvi/ivorywhite.png' }
    ],
    variants: [
      { name: 'Myvi 1.3L G (Without PSDA) (D-CVT)', price: 'RM 46,500', installment: '', features: [] },
      { name: 'Myvi 1.3L G (D-CVT)', price: 'RM 48,500', installment: '', features: [] },
      { name: 'Myvi 1.3L X (D-CVT)', price: 'RM 50,900', installment: '', features: [] },
      { name: 'Myvi 1.3L H (D-CVT)', price: 'RM 54,900', installment: '', features: [] },
      { name: 'Myvi 1.3L AV (D-CVT)', price: 'RM 59,900', installment: '', features: [] },
    ],
    safety: [
      '5-Star ASEAN NCAP Safety Rating',
      'Advanced Safety Assist (A.S.A) 2.0',
      'Vehicle Stability Control (VSC)',
      'Traction Control (TRC)',
      'Hill-Start Assist (HSA)',
      'Anti-lock Braking System (ABS) with Electronic Brake Distribution (EBD)'
    ],
    features: [
      { title: 'Best-Selling', description: 'Malaysia\'s most popular car with millions of satisfied owners.' },
      { title: 'Versatile', description: 'Perfect for city driving, long trips, and everything in between.' },
      { title: 'Reliable', description: 'Built to last with proven durability and low maintenance costs.' }
    ],
    exterior: [
      { name: 'Daytime Running Lights', image: 'features/myvi/daytime_lights_thumb_1x.webp' },
      { name: 'Auto On-Off Headlamps With Follow-Me-Home & Leaving Home Functions', image: 'features/myvi/autoonoff_headlamps_thumb_1x.webp' },
      { name: 'Auto Folding Side Mirror', image: 'features/myvi/autofold_sidemirror_thumb_1x.webp' }
    ],
    interior: [
      { name: 'New Meter Design With TFT Display', image: 'features/myvi/conv_newtftdisplay_thumb_1x.webp' },
      { name: 'Power Mode Drive', image: 'features/myvi/conv_powermode_thumb_1x.webp' },
      { name: 'Multimedia System With \'Smart Link\' & HDMI', image: 'features/myvi/conv_mmediasystem_thumb_1x.webp' },
      { name: 'Voice Recognition', image: 'features/myvi/conv_voicerecognition_thumb_1x.webp' },
      { name: 'Auto Lock & Unlock', image: 'features/myvi/conv_autolockunlock_thumb_1x.webp' },
      { name: 'Integrated Driving Video Recorder (DVR)', image: 'features/myvi/conv_dvr_thumb_1x.webp' },
      { name: 'Built-in Toll Reader', image: 'features/myvi/conv_tollbreader_thumb_1x.webp' }
    ],
    gearupExterior: [
      { name: 'Ace Body Kit', image: 'features/myvi/acebodykit-popup.webp' },
      { name: 'Rear Spoiler', image: 'features/myvi/myvi_rearspoiler_thumb_1x.webp' },
      { name: 'Door Visors', image: 'features/myvi/myvi_doorvisors_thumb_1x.webp' },
      { name: 'Chrome Side Mirror Garnish', image: 'features/myvi/myvi_chromesidemirror_thumb_1x.webp' },
      { name: 'Chrome Window Garnish', image: 'features/myvi/myvi_chromewindow_thumb_1x.webp' },
      { name: 'Side Door Moulding With Chrome Line', image: 'features/myvi/myvi_sidedoormoulding_thumb_1x.webp' }
    ],
    gearupInterior: [
      { name: 'ACE Seat Covers', image: 'features/myvi/conv_gup_seatcovers.gif' },
      { name: 'LED Scuff Plates', image: 'features/myvi/conv_gup_ledscuffplates.gif' },
      { name: 'Floor Lighting', image: 'features/myvi/conv_gup_floorlighting.gif' },
      { name: 'Magnetic Sun Shades', image: 'features/myvi/conv_gup_magneticshade_thumb.webp' },
      { name: 'Chrome Scuff Plates', image: 'features/myvi/conv_gup_chromescuffplates.gif' },
      { name: 'Luggage Tray', image: 'features/myvi/conv_gup_luggagetray_thumb_1x.webp' },
      { name: 'Coil Mats with Mesh Top', image: 'features/myvi/conv_gup_coilmatsmeshtop_thumb_1x.webp' },
      { name: 'Coil Mats', image: 'features/myvi/conv_gup_coilmats_thumb_1x.webp' },
      { name: 'Door Comfort', image: 'features/myvi/conv_gup_doorcomfort_thumb_1x.webp' },
      { name: 'Hood Insulator', image: 'features/myvi/conv_gup_dhoodinsulator_thumb_1x.webp' },
      { name: 'Utility Package', image: 'features/myvi/myvi_guputilitypackage_thumb_1x.webp' },
      { name: 'Illumination Package', image: 'features/myvi/myvi_gupillumintationpackage_thumb_1x.webp' }
    ]
  },
  {
    id: 'alza',
    name: 'Alza',
    tagline: 'FAMILY FIRST',
    price: 'RM62,500',
    image: 'alza.webp',
    imageinfo: 'alza_info.webp',
    category: 'MPV',
    description: 'The perfect 7-seater for your family. Spacious, comfortable, and versatile.',
    colors: [
      { name: 'Elegant Black', hex: '#0C0C0C', image: 'colors/alza/elegantblack.png' },
      { name: 'Garnet Red', hex: '#872124', image: 'colors/alza/garnetred.png' },
      { name: 'Glittering Silver', hex: '#C0C0C0', image: 'colors/alza/glitteringsilver.png' },
      { name: 'Ivory White', hex: '#FFFFF0', image: 'colors/alza/ivorywhite.png' },
      { name: 'Vintage Brown', hex: '#634732', image: 'colors/alza/vintagebrown.png' }
    ],
    variants: [
      { name: 'Alza 1.5 X (D-CVT)', price: 'RM 62,500', installment: '', features: [] },
      { name: 'Alza 1.5 H (D-CVT)', price: 'RM 68,000', installment: '', features: [] },
      { name: 'Alza 1.5 AV (D-CVT)', price: 'RM 75,500', installment: '', features: [] }
    ],
    safety: [
      '5-Star ASEAN NCAP Safety Rating',
      'Advanced Safety Assist (A.S.A) 2.0',
      'Vehicle Stability Control (VSC)',
      'Traction Control (TRC)',
      'Anti-lock Braking System (ABS) with Electronic Brake Distribution (EBD)'
    ],
    features: [
      { title: '7 Seater', description: 'Spacious interior with flexible seating arrangements for your family.' },
      { title: 'Large Boot Space', description: 'Ample cargo space even with all seats in use.' },
      { title: 'Family Friendly', description: 'Designed with families in mind, safety and comfort first.' }
    ],
    exterior: [
      { name: 'Chrome & Glossy Black Front Grilles', image: 'features/alza/alza_style_grille_thumb_1_5x.webp' },
      { name: 'LED Headlamps With Sequential Side Turn Signals', image: 'features/alza/alza_style_ledheadlights_thumb_1_5x.webp' },
      { name: 'LED Front Fog Lamps', image: 'features/alza/alza_style_ledfoglamp_thumb_1_5x.webp' },
      { name: 'LED Back Door Tail Lamps', image: 'features/alza/alza_style_ledbackdoorlamp_thumb_1_5x.webp' },
      { name: 'Auto Folding Side Mirrors With LED Turn Signals', image: 'features/alza/alza_style_autoflipsidemirror_thumb_1_5x.webp' },
      { name: '16" Alloy Rims With Rear Disc Brake', image: 'features/alza/style_alza_16alloyrims_thumb.webp' },
      { name: 'Key Free Entry', image: 'features/alza/alza_conv_keyfreeentry_thumb_1x.webp' },
      { name: 'Turning Radius of 5 meters', image: 'features/alza/alza_conv_5mradius_thumb_1_5x.webp' }
    ],
    interior: [
      { name: 'Leather Steering Wheel With Switch Controls', image: 'features/alza/alza_conv_leathersteering_thumb_1_5x.webp' },
      { name: 'Electronic Parking Brake', image: 'features/alza/alza_conv_electronicbrake_thumb_1_5x.webp' },
      { name: '7” TFT Multi-Info Display', image: 'features/alza/alza_conv_tftdisplay_thumb_1_5x.webp' },
      { name: 'Push Start-Stop-Button', image: 'features/alza/alza_conv_startbutton_thumb_1_5x.webp' },
      { name: 'Digital Air Conditioner Controls with Off Button', image: 'features/alza/alza_conv_digitalaircondbtn_thumb_1x.webp' },
      { name: '3 USB Ports', image: 'features/alza/alza_conv_3usbports_thumb_1x.webp' },
      { name: '2 x 12V Power Sockets', image: 'features/alza/alza_conv_12vpowersockets_thumb_1x.webp' }
    ],
    gearupExterior: [
      { name: 'PRIME Bodykit', image: 'features/alza/alza_gupprimebodykit.gif' },
      { name: 'Door Visors', image: 'features/alza/alza_style_gupdoorvisors_thumb.webp' },
      { name: 'Utility Package', image: 'features/alza/alza_conv_guputilitypkg_thumb_1_5x.webp' }
    ],
    gearupInterior: [
      { name: 'PRIME Seat Covers', image: 'features/alza/alza-prime-seat-covers.gif' },
      { name: 'LED Scuff Plates', image: 'features/alza/alza-led-scuff-plates.gif' },
      { name: 'Floor Lighting', image: 'features/alza/alza-floor-lighting.gif' },
      { name: 'Coil Mats', image: 'features/alza/alza_conv_gupcoilmat_thumb_1_5x.webp' },
      { name: 'Luggage Tray', image: 'features/alza/alza_conv_gupluggagetray_thumb_1_5x.webp' },
      { name: 'Hood Insulator', image: 'features/alza/alza_conv_guphoodinsulator_thumb_1_5x.webp' },
      { name: 'Utility Package', image: 'features/alza/alza_conv_guputilitypkg_thumb_1_5x.webp' }
    ]
  },
  {
    id: 'ativa',
    name: 'Ativa',
    tagline: 'ADVENTURE READY',
    price: 'RM62,500',
    image: 'ativawebp',
    imageinfo: 'ativa_info.webp',
    category: 'SUV',
    description: 'Your perfect companion for urban adventures and weekend getaways.',
    colors: [
      { name: 'Cobalt Blue', hex: '#1D3DBA', image: 'colors/ativa/cobaltblue.png' },
      { name: 'Delima Red', hex: '#D02D23', image: 'colors/ativa/delimared.png' },
      { name: 'Diamond White', hex: '#E6E6E6', image: 'colors/ativa/diamondwhite.png' },
      { name: 'Glittering Silver', hex: '#C0C0C0', image: 'colors/ativa/glitteringsilver.png' },
      { name: 'Granite Grey', hex: '#71797E', image: 'colors/ativa/granitegrey.png' }
    ],
    variants: [
      { name: 'Ativa 1.0L TURBO X (Metallic)', price: 'RM 62,500', installment: 'RM /mth', features: [] },
      { name: 'Ativa 1.0L TURBO H (Metallic)', price: 'RM 67,300', installment: 'RM /mth', features: [] },
      { name: 'Ativa 1.0L TURBO H (Special Metallic)', price: 'RM 67,800', installment: 'RM /mth', features: [] },
      { name: 'Ativa 1.0L TURBO AV (Metallic)', price: 'RM 72,600', installment: 'RM /mth', features: [] },
      { name: 'Ativa 1.0L TURBO AV (Special Metallic)', price: 'RM 73,100', installment: 'RM /mth', features: [] },
      { name: 'Ativa 1.0L TURBO AV (2-Tone Special Metallic Black Roof)', price: 'RM 73,400', installment: 'RM /mth', features: [] },
    ],
    safety: [
      '5-Star ASEAN NCAP Safety Rating',
      'Advanced Safety Assist (A.S.A) 2.0',
      'Vehicle Stability Control (VSC)',
      'Traction Control (TRC)',
      'Hill-Start Assist (HSA)',
      'Anti-lock Braking System (ABS) with Electronic Brake Distribution (EBD)'
    ],
    features: [
      { title: 'SUV Design', description: 'Bold and modern SUV styling with elevated driving position.' },
      { title: 'All-Terrain', description: 'Ready for both city streets and weekend adventures.' },
      { title: 'Advanced Tech', description: 'Latest safety and convenience features for modern driving.' }
    ],
    exterior: [
      { name: 'Electrostatic switch door handle', image: 'features/ativa/ativa_conv_electorstaticdoor_thumb_1x.webp' },
      { name: 'Auto fold side mirror', image: './features/ativa/ativa_conv_autofoldsidemirror_thumb_1x.webp' },
      { name: 'High ground clearance for rough terrains', image: './features/ativa/ativa_conv_highclearance_thumb_1x.webp' },
      { name: 'Blaze Bodykit, Door Visors, and Rear Bumper Protector', image: './features/ativa/ativa_conv_highclearance_thumb_1x.webp' },
    ],
    interior: [
      { name: 'Infotainment within easy reach', image: 'features/ativa/ativa_conv_infotainment_thumb_1x.webp' },
      { name: 'Console Box with Padded Armrest', image: 'features/ativa/ativa_conv_consolebox_thumb_1x.webp' },
      { name: 'Open Tray with Illumination', image: 'features/ativa/ativa_conv_opentrayillumination_thumb_1x.webp' },
      { name: 'Side Pocket', image: 'features/ativa/ativa_conv_sidepocket_thumb_1x.webp' },
      { name: 'Built-in Cup Holder', image: 'features/ativa/ativa_conv_cupholder_thumb_1x.webp' },
      { name: 'Vanity Mirror with Card Slot', image: 'features/ativa/ativa_conv_vanitymirror_thumb_1x.webp' },
      { name: 'Digital air conditioner controller with quick OFF button', image: 'features/ativa/ativa_conv_digitalaircondoffbtn_thumb_1x.webp' },
      { name: 'Rear USB ports', image: 'features/ativa/ativa_conv_rearusbports_thumb_1x.webp' },
      { name: 'High driver seating position. Greater visibility of the front, side and rear', image: 'features/ativa/ativa_conv_highdriverseating_thumb_1x.webp' }
    ],
    gearupExterior: [
      { name: 'Blaze Bodykit', image: 'features/ativa/ativa_style_gupblazebodykit_thumb.gif' },
      { name: 'Door Visors', image: 'features/ativa/ativa_style_gupdoorvisors_thumb_1_5x.webp' },
      { name: 'Rear Bumper Protector', image: 'features/ativa/ativa_style_guprearbumperprotector_thumb_1_5x.webp' }
    ],
    gearupInterior: [
      { name: 'Seat Covers with Red Stitching Design', image: 'features/ativa/ativa_conv_gupseatcover.gif' },
      { name: 'LED Scuff Plates', image: 'features/ativa/ativa_conv_gupledplates_thumb_1_5x.webp' },
      { name: 'Floor Lighting', image: 'features/ativa/ativa_conv_gupfloorlighting_thumb_1_5x.webp' },
      { name: 'Coil Mats', image: 'features/ativa/ativa_conv_gupcoilmats_thumb_1_5x.webp' },
      { name: 'Luggage Tray', image: 'features/ativa/ativa_conv_guptray_thumb_1_5x.webp' },
      { name: 'Luggage Net', image: 'features/ativa/ativa_conv_gupluggagenet_thumb_1_5x.webp' },
      { name: 'Hood Insulator', image: 'features/ativa/ativa_conv_guphoodinsulator_thumb_1_5x.webp' },
      { name: 'Utility Package', image: 'features/ativa/ativa_conv_guputilitypkg_thumb_1_5x.webp' }
    ]
  },
  {
    id: 'aruz',
    name: 'Aruz',
    tagline: 'BOLD & SPACIOUS',
    price: 'RM72,900',
    image: 'aruz.webp',
    imageinfo: 'aruz_info.webp',
    category: 'SUV',
    description: 'A bold 7-seater SUV that combines style, space, and capability.',
    colors: [
      { name: 'Elegant Black', hex: '#0C0C0C', image: 'colors/aruz/elegantblack.webp' },
      { name: 'Garnet Red', hex: '#872124', image: 'colors/aruz/garnetred.webp' },
      { name: 'Glittering Silver', hex: '#C0C0C0', image: 'colors/aruz/glitteringsilver.webp' },
      { name: 'Granite Grey', hex: '#71797E', image: 'colors/aruz/granitegrey.webp' },
      { name: 'Ivory White', hex: '#FFFFF0', image: 'colors/aruz/ivorywhite.webp' },
      { name: 'Vintage Brown', hex: '#634732', image: 'colors/aruz/vintagebrown.webp' }
    ],
    variants: [
      { name: 'Aruz 1.5 X (Automatic)', price: 'RM 72,900', installment: '', features: [] },
      { name: 'Aruz 1.5 AV (Automatic)', price: 'RM 77,900', installment: '', features: [] },
    ],
    safety: [
      '5-Star ASEAN NCAP Safety Rating',
      'Advanced Safety Assist (A.S.A) 2.0',
      'Vehicle Stability Control (VSC)',
      'Traction Control (TRC)',
      'Anti-lock Braking System (ABS) with Electronic Brake Distribution (EBD)'
    ],
    features: [
      { title: '7 Seater SUV', description: 'Spacious interior with three rows of comfortable seating.' },
      { title: 'Powerful Engine', description: '1.5L engine with excellent performance and reliability.' },
      { title: 'Premium Features', description: 'Loaded with advanced features for comfort and safety.' }
    ],
    exterior: [
      { name: 'Elevated Convenience - Side Step', image: 'features/aruz/aruz_b_style_elevatedsidestep_thumb_2x.webp' },
      { name: 'Front Grille With Black Chrome & Glossy Black Finish*', image: 'features/aruz/aruz_b_style_frontgrille_thumb_2x.webp' },
      { name: 'LED Headlamps with Follow-me-home Function and Light Guides', image: 'features/aruz/aruz_b_style_ledheadlamp_thumb_2x.webp' },
      { name: 'Fog Lamps with Stylish Bezel', image: 'features/aruz/aruz_b_style_foglamps_thumb_2x.webp' },
      { name: 'Front Bumper with Silver Painted Diffuser', image: 'features/aruz/aruz_b_style_frontbumper_thumb_2x.webp' },
      { name: 'Sporty Roof Rail', image: 'features/aruz/aruz_b_style_sportyrail_thumb_2x.webp' },
      { name: 'Rear Bumper with Silver Painted Diffuser', image: 'features/aruz/aruz_b_style_rearbumper_thumb_2x.webp' },
      { name: 'Backdoor Garnish with Chrome and Glossy Black Finish', image: 'features/aruz/aruz_b_style_backdoorgarnish_thumb_2x.webp' },
      { name: 'LED Rear Combination Lamps', image: 'features/aruz/aruz_b_style_ledheadlamp_thumb_2x.webp' },
      { name: 'Rear Spoiler', image: 'features/aruz/aruz_b_style_rearspoiler_thumb_2x.webp' },
      { name: '17-inch Alloy Rims', image: 'features/aruz/aruz_b_style_17incalloyrims_thumb_2x.webp' }
    ],
    interior: [
      { name: 'Elevated Safety - Auto-lock Feature', image: 'features/aruz/aruz_conv_safteyautolock_thumb_1x.webp' },
      { name: 'Adjustable Leather-wrapped Steering with Audio and ‘Receive Call’ Control*', image: 'features/aruz/aruz_b_conv_adjiustablesteering_thumb_2x.webp' },
      { name: 'Semi Bucket Leather Seats', image: 'features/aruz/aruz_conv_semibucketleatherseats_thumb_2x.webp' },
      { name: 'Rear Aircond Vents', image: 'features/aruz/aruz_conv_reaaircondvents_thumb_1x.webp' },
      { name: 'Gated Gear Shifts', image: 'features/aruz/aruz_conv_gatedgear_thumb_1x.webp' },
      { name: 'Side Mirror Control', image: 'features/aruz/aruz_conv_sidemirrorctrl_thumb_1x.webp' },
      { name: 'Sporty White-illuminated Meter Panel with LCD Info Display', image: 'features/aruz/aruz_conv_sportypanel_thumb.webp' },
      { name: 'Driver Seat Height Adjuster', image: 'features/aruz/aruz_conv_driveseatadjuster_thumb_1x.webp' }
    ],
    gearupExterior: [
      { name: 'Front Bumper Kit', image: 'features/aruz/Rugged Package.webp' },
      { name: 'Rear Bumper Kit', image: 'features/aruz/aruz_style_rearbumperkit_thumb_1_5x.webp' },
      { name: 'Door Visor', image: 'features/aruz/aruz_style_doorvisor_thumb_1_5x.webp' },
      { name: 'Rear Bumper Protector', image: 'features/aruz/aruz_conv_luggagetray_thumb_1_5x.webp' },
      { name: 'Rugged Package', image: 'features/aruz/aruz_style_rearprotector_thumb_1_5x.webp' }
    ],
    gearupInterior: [
      { name: 'Seat Covers with Red Stitching Design', image: 'features/aruz/aruz_conv_gupseatcovers_thumb_1_5x.webp' },
      { name: 'Centre Arm Rest', image: 'features/aruz/aruz_conv_gupcentrearmrest_thumb_1_5x.webp' },
      { name: 'Chrome Scuff Plates', image: 'features/aruz/aruz_conv_chromescuffplates_thumb_1_5x.webp' },
      { name: 'Luggage Tray', image: 'features/aruz/aruz_conv_luggagetray_thumb_1_5x.webp' },
      { name: 'Coil Mats', image: 'features/aruz/aruz_conv_coilmates_thumb_1_5x.webp' },
      { name: 'Hood Insulator', image: 'features/aruz/aruz_conv_hoodinsulator_thumb_1_5x.webp' },
      { name: 'Door Comfort', image: 'features/aruz/aruz_conv_doorcomfort_thumb_1_5x.webp' },
      { name: 'Utility Package', image: 'features/aruz/aruz_style_guputilitypackage_thumb_1_5x.webp' }
    ]
  },
  {
    id: 'traz',
    name: 'Traz',
    tagline: 'PREMIUM ELEVATED',
    price: 'RM76,100',
    image: 'traz.webp',
    imageinfo: 'traz_info.webp',
    category: 'SUV',
    description: 'The premium 7-seater SUV that elevates your driving experience.',
    colors: [
      { name: 'Cranberry Red', hex: '#9B111E', image: 'colors/traz/cranberryred.png' },
      { name: 'Electric Blue (2 Tone)', hex: '#7DF9FF', image: 'colors/traz/electricblue2tone.png' },
      { name: 'Glittering Silver', hex: '#C0C0C0', image: 'colors/traz/glitteringsilver.png' },
      { name: 'Glittering Silver (2 Tone)', hex: '#C0C0C0', image: 'colors/traz/glitteringsilver2tone.png' },
      { name: 'Granite Grey', hex: '#71797E', image: 'colors/traz/granitegrey.png' },
      { name: 'Ivory White', hex: '#FFFFF0', image: 'colors/traz/ivorywhite.png' }
    ],
    variants: [
      { name: 'Traz 1.5 X (D-CVT)', price: 'RM 76,100', installment: '', features: [] },
      { name: 'Traz 1.5 H (D-CVT)', price: 'RM 81,100', installment: '', features: [] },
      { name: 'Traz 1.5 H 2T (D-CVT)', price: 'RM 82,000', installment: '', features: [] }
    ],
    safety: [
      '5-Star ASEAN NCAP Safety Rating',
      'Advanced Safety Assist (A.S.A) 2.0',
      'Vehicle Stability Control (VSC)',
      'Traction Control (TRC)',
      '360° Camera System',
      'Anti-lock Braking System (ABS) with Electronic Brake Distribution (EBD)'
    ],
    features: [
      { title: 'Premium SUV', description: 'The most premium offering in the Perodua lineup with luxury features.' },
      { title: '7 Seater Luxury', description: 'Spacious and luxurious interior for the whole family.' },
      { title: 'Advanced Safety', description: 'Comprehensive safety features including 360° camera system.' }
    ],
    exterior: [
      // { name: 'LED Headlamps', image: 'features/led-headlamps.jpg' },
      // { name: 'Premium Front Grille', image: 'features/premium-grille.jpg' },
      // { name: '18" Alloy Rims', image: 'features/alloy-rims-18.jpg' },
      // { name: 'Retractable Side Mirrors', image: 'features/side-mirrors.jpg' },
      // { name: 'Roof Rails', image: 'features/roof-rails.jpg' },
      // { name: 'Smart Entry with Smart Key', image: 'features/smart-key.jpg' }
    ],
    interior: [
      // { name: 'Premium Leather Seats', image: 'features/premium-leather-seats.jpg' },
      // { name: 'Smart Entry with Smart Key and Push Start/Stop Button', image: 'features/push-start.jpg' },
      // { name: 'Advanced Meter Combi', image: 'features/advanced-meter.jpg' },
      // { name: 'Premium Multimedia System', image: 'features/premium-multimedia.jpg' },
      // { name: 'Multiple USB Ports', image: 'features/usb-port.jpg' },
      // { name: 'Luxury 7-Seater Layout', image: 'features/luxury-seating.jpg' }
    ],
    gearupExterior: [
      // { name: 'Premium Body Kit', image: 'features/gearup/premium-body-kit.jpg' },
      // { name: 'Chrome & Black Grille Package', image: 'features/gearup/chrome-black-grille.jpg' },
      // { name: 'Custom 19" Premium Alloy Rims', image: 'features/gearup/premium-rims-19.jpg' },
      // { name: 'Panoramic Roof Rails', image: 'features/gearup/panoramic-rails.jpg' },
      // { name: 'Power Side Steps', image: 'features/gearup/power-side-steps.jpg' }
    ],
    gearupInterior: [
      // { name: 'Nappa Leather Seat Upgrade', image: 'features/gearup/nappa-leather.jpg' },
      // { name: 'Carbon Fiber Interior Package', image: 'features/gearup/carbon-interior.jpg' },
      // { name: 'Premium Sound System Upgrade', image: 'features/gearup/premium-sound.jpg' },
      // { name: '360° Dash Cam System', image: 'features/gearup/360-dash-cam.jpg' }
    ]
  }
];

export const getCarById = (id) => {
  return cars.find(car => car.id === id);
};

export const getOtherCars = (currentCarId) => {
  return cars.filter(car => car.id !== currentCarId).slice(0, 3);
};
